import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit,Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { CreditGeniusService } from '../../../Services/credit-genius.service';
import { environment } from '../../../environments/environment';
import { CommonModule , isPlatformBrowser } from '@angular/common';
import { NavbarComponent } from '../../Components/navbar/navbar.component';
import { FooterComponent } from '../../Components/footer/footer.component';
@Component({
  selector: 'app-pingyo-loan-process',
  standalone: true,
  imports: [CommonModule, NavbarComponent, FooterComponent],
  templateUrl: './pingyo-loan-process.component.html',
  styleUrls: ['./pingyo-loan-process.component.css']
})
export class PingyoLoanProcessComponent implements OnInit {
  imgSrc = environment.imgBasURL;
  TextLoader!: string;
  textIndex = 0;
  countnumber :any;
  loadingText = ["Gathering loan Providers", "Analysing eligibility", "Matching with the best rates"]
  loadData : any;
  MaxCount: number = 25;
  RetryCount: number = 1;
  IsLanderFounded : boolean = false;
  waitLoader: boolean = false;
  countdown!:number;
  watcher:any;
  timerDuration:number =4000;
  UpdateLoader() {
    setTimeout(() => {
      console.log("b");
     // console.log(this.TextLoader)
      if (this.loadingText[this.textIndex + 1] != null) {
        this.TextLoader = this.loadingText[++this.textIndex];
        this.UpdateLoader()
      }
      else {
        this.waitLoader=true;
        this.countdown = 50;
        //this.textIndex=-1;
        //this.UpdateLoader();
        var _this = this;
        console.log("interval starts");
        this.watcher =setInterval(function() {
          console.log("c");
          _this.countdown = --_this.countdown <= 0 ? 0 : _this.countdown;
          console.log(_this.countdown);
        if (_this.countdown == 0) {
          console.log("d");
          _this.clearTheInterval(_this.watcher,1);
        }
        }, 1000);
      }
    }, 2500);
  }
  constructor(private _creditGeniusService: CreditGeniusService, private router: Router, @Inject(PLATFORM_ID) private platformId: Object) { }
  ngOnInit(): void {
    this.TextLoader = this.loadingText[this.textIndex];
    console.log("A");
    this.UpdateLoader();
    if (isPlatformBrowser(this.platformId)) {
    this.loadData = JSON.parse(sessionStorage.getItem('loandata') || '{}');
    this.CheckStatusPingYo(this.loadData);
    sessionStorage.removeItem('loandata');
    this.countnumber = document.getElementById('countdown-number');}
  }

  CheckStatusPingYo(statusRequest: any) {
    this._creditGeniusService.CheckStatusPingYo(statusRequest).subscribe(
      (result) => {
        console.log('%'+result.data.percentageComplete);
        if (result.data != null && result.data.percentageComplete == 100) {
          var redirectionUrl = result.data.redirectionUrl;
          if (redirectionUrl != null) {
            this.IsLanderFounded=true;
            this.waitLoader=false;
            console.log("f");
            this.TextLoader="Congratulations!, Lender is found for you, redirecting..."
            this.clearTheInterval(this.watcher,2);
            window.open(result.data.redirectionUrl,"_self");

          }
          else {
            this.clearTheInterval(this.watcher,3);
            this.router.navigate(['/noresult']);
          }
        }
        else {
          if (this.RetryCount <= this.MaxCount) {
            if(this.timerDuration>2000)
            this.timerDuration=this.timerDuration-400
              this.RetryCount++;
            setTimeout(() => {
              this.CheckStatusPingYo(statusRequest);
          }, this.timerDuration);
          }
          else{
            this.clearTheInterval(this.watcher,4);
            this.router.navigate(['/noresult']);
          }
        }
      },
      (err: HttpErrorResponse) => {
        console.log('Catch exception: ' + err);
       }
    
    );
  }
clearTheInterval(obj:any,counter:number) {
  console.log("interval clear: "+counter);
  clearInterval(obj);

}

}
